/**
 * @description CP Integrations > Connectors > Connector Flags (LYN-267)
 *
 * @dependencies SourceConnectorPanel, sourceConnectorsApi
 * @notes No shop password. Last save wins with SA.
 */

import { useCallback, useEffect, useState } from 'react';
import SourceConnectorPanel from '../../components/source-connectors/SourceConnectorPanel';
import {
  listSourceConnectorFlags,
  listSourceConnectors,
  saveSourceConnector,
  saveSourceConnectorFlag,
  uploadSourceConnectorLogo
} from '../../services/api/sourceConnectorsApi';

export default function ChannelPartnerIntegrations() {
  const [connectors, setConnectors] = useState(null);
  const [salesOrganizations, setSalesOrganizations] = useState([]);
  const [flagsByConnectorId, setFlagsByConnectorId] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    const res = await listSourceConnectors();
    const list = res.data || [];
    setConnectors(list);
    setSalesOrganizations(res.meta?.salesOrganizations || []);
    const flags = {};
    await Promise.all(list.map(async (connector) => {
      const flagRes = await listSourceConnectorFlags(connector.id);
      flags[connector.id] = flagRes.data || [];
    }));
    setFlagsByConnectorId(flags);
  }, []);

  useEffect(() => {
    load().catch((err) => {
      setError(err.response?.data?.error?.message || 'Failed to load connectors');
    });
  }, [load]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Integrations</h1>
      <p className="text-sm text-gray-500 mb-6">Connectors · Connector Flags</p>
      <SourceConnectorPanel
        connectors={connectors}
        salesOrganizations={salesOrganizations}
        flagsByConnectorId={flagsByConnectorId}
        busy={busy}
        error={error}
        onSaveCatalog={async (connectorId, body) => {
          setBusy(true);
          setError(null);
          try {
            await saveSourceConnector(connectorId, body);
            await load();
          } catch (err) {
            setError(err.response?.data?.error?.message || 'Failed to save connector');
          } finally {
            setBusy(false);
          }
        }}
        onSaveFlag={async (connectorId, body) => {
          setBusy(true);
          setError(null);
          try {
            await saveSourceConnectorFlag(connectorId, body);
            await load();
          } catch (err) {
            setError(err.response?.data?.error?.message || 'Failed to save flag');
          } finally {
            setBusy(false);
          }
        }}
        onUploadLogo={async (connectorId, file) => {
          setBusy(true);
          setError(null);
          try {
            await uploadSourceConnectorLogo(connectorId, file);
            await load();
          } catch (err) {
            setError(err.response?.data?.error?.message || 'Failed to upload logo');
          } finally {
            setBusy(false);
          }
        }}
      />
    </div>
  );
}
